import { exactCurrencyFormatter } from "../../../utils"
import type { PlannedCell } from "../api/forecast_io_api"

interface PlannedCellsTableProps {
  cells: PlannedCell[]
  /** Show the file line a cell came from (imports); seeds have none. */
  show_line?: boolean
  /** Rows rendered before the "… and N more" line. */
  limit?: number
  className?: string
}

/** The dry-run preview shared by the import and seed dialogs: one line per leaf × period. */
export function PlannedCellsTable(props: PlannedCellsTableProps) {
  const { cells, show_line = false, limit = 200, className } = props
  const shown = cells.slice(0, limit)
  return (
    <div className={`max-h-72 overflow-auto rounded-md border border-gray-200 ${className ?? ""}`}>
      <table className="w-full text-xs">
        <thead className="sticky top-0 bg-gray-50 text-left text-gray-600">
          <tr>
            {show_line ? <th className="px-2 py-1.5 font-medium">Line</th> : null}
            <th className="px-2 py-1.5 font-medium">Customer</th>
            <th className="px-2 py-1.5 font-medium">Product line</th>
            <th className="px-2 py-1.5 font-medium">SKU</th>
            <th className="px-2 py-1.5 font-medium">Period</th>
            <th className="px-2 py-1.5 text-right font-medium">Stores</th>
            <th className="px-2 py-1.5 text-right font-medium">Cases</th>
            <th className="px-2 py-1.5 text-right font-medium">Revenue</th>
            <th className="px-2 py-1.5 text-right font-medium">Price / case</th>
            <th className="px-2 py-1.5 font-medium">Result</th>
          </tr>
        </thead>
        <tbody>
          {shown.map((cell: PlannedCell) => (
            <tr key={`${cell.path_key}-${cell.period}-${cell.line}`} className="border-t border-gray-100">
              {show_line ? <td className="px-2 py-1 tabular-nums text-gray-500">{cell.line}</td> : null}
              <td className="px-2 py-1">{cell.customer}</td>
              <td className="px-2 py-1">{cell.product_line}</td>
              <td className="px-2 py-1">{cell.sku}</td>
              <td className="px-2 py-1 tabular-nums">{cell.period}</td>
              <td className="px-2 py-1 text-right tabular-nums">{cell.store_count.toLocaleString()}</td>
              <td className="px-2 py-1 text-right tabular-nums">{Number(cell.cases).toLocaleString()}</td>
              <td className="px-2 py-1 text-right tabular-nums">{exactCurrencyFormatter(Number(cell.volume_dollars))}</td>
              <td className="px-2 py-1 text-right tabular-nums">{exactCurrencyFormatter(Number(cell.case_cost))}</td>
              <td className="px-2 py-1">
                {cell.creates_node ? (
                  <span className="rounded bg-blue-50 px-1.5 py-0.5 text-blue-700">new SKU row</span>
                ) : cell.replaces_existing ? (
                  <span className="rounded bg-amber-50 px-1.5 py-0.5 text-amber-800">replaces</span>
                ) : (
                  <span className="rounded bg-emerald-50 px-1.5 py-0.5 text-emerald-700">adds</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {cells.length > shown.length ? (
        <p className="px-2 py-1.5 text-xs text-gray-500">… and {(cells.length - shown.length).toLocaleString()} more</p>
      ) : null}
    </div>
  )
}
